import keymirror from 'keymirror';
import Proptypes from 'prop-types';

const personalLabelMap = keymirror({
  noLabel: null,
  number: null,
  numberDesc: null,
  alphabet: null,
});

export const personalLabelTypeList = Object.keys(personalLabelMap);

export const personalLabelProptypes = Proptypes.oneOf(Object.keys(personalLabelMap));

export default personalLabelMap;
